export default __webpack_public_path__ + "static/funds-c8eab99a474572acea113ef573e66286.jpg";